import { render, staticRenderFns } from "./BuyBtn.vue?vue&type=template&id=1a79160e&scoped=true&"
import script from "./BuyBtn.vue?vue&type=script&lang=js&"
export * from "./BuyBtn.vue?vue&type=script&lang=js&"
import style0 from "./BuyBtn.vue?vue&type=style&index=0&id=1a79160e&lang=sass&scoped=true&"
import style1 from "./BuyBtn.vue?vue&type=style&index=1&id=1a79160e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79160e",
  null
  
)

export default component.exports